import script from "./orderitemsostav.vue?vue&type=script&setup=true&lang=js"
export * from "./orderitemsostav.vue?vue&type=script&setup=true&lang=js"

import "./orderitemsostav.vue?vue&type=style&index=0&id=4d1c81cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d1c81cf"]])

export default __exports__